import styled from 'styled-components'

export const StyledLonRedeemContainer = styled.div`
  padding: 20px;
  .redeem-title {
    font-weight: 500;
    font-size: 21px;
    color: ${({ theme }) => theme.colors.textContent};
  }
  .description {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 14px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
    padding-bottom: 21px;
    margin-top: 27px;
    text-align: justify;
  }

  .bottom-area {
    display: flex;
    justify-content: flex-end;
    .triger-unlock-btn {
      cursor: pointer;
      margin-top: 46px;
      background: ${({ theme }) => theme.colors.primary};
      border-radius: 628px;
      color: #ffffff;
      font-weight: 500;
      font-size: 17px;
      padding: 10px 38px;
      border: 0;
      outline: none;
    }
  }
`

export const StyledCommonTipsContent = styled.section`
  margin-top: 25px;
  .tips-item {
    .num {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 500;
      font-size: 13px;
      background: rgba(95, 77, 188, 0.1);
      border-radius: 4px;
      padding: 4px;
      margin-right: 12px;
    }
    .tips {
      color: #5f55a9;
      font-weight: 500;
      font-size: 17px;
    }
  }
  .tips-2 {
    margin-top: 14px;
  }
  @media screen and (max-width: 640px) {
    .tips-item {
      .tips {
        font-size: 15px;
      }
    }
  }
`

export const StyledForceRedeemContainer = styled.div`
  padding: 20px;

  .head-title {
    font-weight: 500;
    font-size: 21px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
    padding-bottom: 25px;
    color: ${({ theme }) => theme.colors.textContent};
  }
  .bottom-btn-area {
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;
    .keep-waiting-btn,
    .confirm-redeem {
      font-weight: 500;
      font-size: 17px;
      border-radius: 628px;
      padding: 10px 38px;
      cursor: pointer;
      outline: none;
      border: 0;
    }
    .keep-waiting-btn {
      background: rgba(95, 77, 188, 0.2);
      color: ${({ theme }) => theme.colors.primary};
      margin-right: 11px;
    }
    .confirm-redeem {
      color: #ffffff;
      background: ${({ theme }) => theme.colors.primary};
    }
  }
  @media screen and (max-width: 640px) {
    .head-title {
      font-size: 15px;
      padding-bottom: 16px;
    }
  }
`

export const StyledLonUnlockCountdownContainer = styled.div`
  padding: 20px;

  .countdown-title {
    color: ${({ theme }) => theme.colors.textContent};
    font-weight: 500;
    font-size: 21px;
  }
  .tips {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 15px;
    margin-top: 11px;
  }
  .count-down-time-area {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 26px;
    .time-area {
      font-weight: 500;
      font-size: 31px;
      background: rgba(95, 77, 188, 0.1);
      border-radius: 16.8889px;
      color: ${({ theme }) => theme.colors.primary};
      padding: 15px 10px;
    }
    .days {
      font-weight: 500;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.primary};
      margin: 0 4px;
    }
    .day {
      padding: 20px;
    }
    .colon {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 500;
      margin: 0 5px;
    }
  }
  .description {
    margin-top: 31px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }
  .bottom-btn-area {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button {
      font-weight: 500;
      font-size: 17px;
      border-radius: 628px;
      padding: 10px 38px;
      cursor: pointer;
      outline: none;
      border: 0;
    }
    .force-redeem-btn {
      background: #fef1f1;
      color: #f67676;
      margin-right: 6px;
    }
    .keep-waiting-btn,
    .redeem-immediate-btn {
      background: ${({ theme }) => theme.colors.primary};
      color: #ffffff;
    }
  }
  @media screen and (max-width: 640px) {
    .count-down-time-area {
      .time-area {
        padding: 16px 10px;
      }
      .day {
        padding: 16px;
      }
    }
    .description {
      margin-top: 45px;
      font-size: 14px;
    }
  }
`

export const StyledRedeemLonModal = styled.div`
  width: 400px;
  position: relative;
  padding: 20px;
  .wait-cooldown-tips {
    padding: 15px;
    background: rgba(254, 182, 29, 0.1);
    border-radius: 8px;
    color: #feb61d;
    font-size: 13px;
  }
  .redeem-title {
    color: ${({ theme }) => theme.colors.textContent};
    font-weight: 500;
    font-size: 21px;
  }
  .tips {
    font-size: 15px;
    color: ${({ theme }) => theme.colors.textTertiary};
    margin-top: 10px;
  }
  .main-content {
    margin-top: 16px;
    padding-bottom: 23px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
    .extractable,
    .pay-fine,
    .estimate-rate {
      margin-bottom: 0;
      display: flex;
      justify-content: space-between;
      .title,
      .value {
        font-size: 17px;
        color: #8982be;
      }
    }
    .widthraw-area {
      position: relative;
      .amount-title {
        padding: 10px 0;
        font-size: 17px;
        color: #8982be;
      }
      .redeem-input-amount {
        width: 100%;
        font-size: 17px;
        color: ${({ theme }) => theme.colors.primary};
        background: #f4f5f6;
        border-radius: 8px;
        border: none;
        padding: 15px 20px;
        margin-bottom: 20px;
        padding-right: 100px;
        &::-webkit-input-placeholder {
          color: ${({ theme }) => theme.colors.textPlaceholder};
        }
      }

      .all-btn {
        position: absolute;
        right: 20px;
        top: 55px;
        background: rgba(95, 77, 188, 0.1);
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 500;
        font-size: 15px;
        cursor: pointer;
        padding: 8px 12px;
        border: none;
        outline: none;
      }
    }
  }
  .estimate-redeem {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;
    .title {
      font-size: 17px;
      color: #8982be;
    }
    .value {
      font-weight: 500;
      font-size: 21px;
      color: #5f55a9;
    }
  }
  .bottom-btn-area {
    display: flex;
    justify-content: flex-end;
    margin-top: 25px;
    .auth-btn,
    .confirm-btn {
      font-weight: 500;
      font-size: 17px;
      border-radius: 628px;
      padding: 10px 54px;
      cursor: pointer;
      border: 0;
      outline: none;
    }
    .auth-btn {
      color: ${({ theme }) => theme.colors.primary};
      margin-right: 5px;
      background: rgba(95, 77, 188, 0.2);
    }
    .confirm-btn {
      color: #fff;
      background: ${({ theme }) => theme.colors.primary};
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 640px) {
    width: 100%;
    .fullpage-content-container {
      padding: 45px 20px 40px !important;
    }
  }
`

export const StyledRedeemLonBlurLayer = styled.div`
  background: #fff;
  filter: blur(30px);
`

export const StyledTipsContent = styled.div`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.textContent};
  text-align: center;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  line-height: 28px;
  transform: translate(-50%, -50%);
  z-index: 99;
`

export const StyledRedeemTipsButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  padding: 10px 54px;
  border-radius: 628px;
  outline: none;
  border: 0;
  color: #ffffff;
  margin-top: 25px;
`
